// ========================= IMPORT DEPENDENCIES ========================= //

import {bootstrap} from 'genesis-packages/core';
import Global from 'pages/Global.js';

// ========================= RUN MAIN SCRIPT ========================= //

bootstrap({

	// Pass your MVT to JS namespace
	context: window.mivaJS,

	// Global Page class
	globalClass: Global,

	// A directory of page classes or scss files to be loaded by matching the `Page_Code` context variable
	pageCodeImports: {
		ACAD: () => import('pages/ACAD/ACAD.js'),
		ACED: () => import('pages/ACED/ACED.js'),
		ACLN: () => import('pages/ACLN/ACLN.js'),
		BASK: () => import('pages/BASK/BASK.js'),
		CABK: () => import('pages/CABK/CABK.js'),
		CPCD: () => import('pages/CPCD/CPCD.js'),
		CTGY: () => import('pages/CTGY/CTGY.js'),
		CTUS: () => import('pages/CTUS/CTUS.js'),
		FAQS: () => import('pages/FAQS/FAQS.js'),
		INVC: () => import('pages/INVC/INVC.js'),
		LOGN: () => import('pages/LOGN/LOGN.js'),
		MORD: () => import('pages/MORD/MORD.js'),
		MULTI_SYSTEM: () => import('pages/MULTI_SYSTEM/MULTI_SYSTEM.js'),
		MULTI_SYSTEMS: () => import('pages/MULTI_SYSTEMS/MULTI_SYSTEMS.js'),
		OCST: () => import('pages/OCST/OCST.js'),
		OPAY: () => import('pages/OPAY/OPAY.js'),
		ORDH: () => import('pages/ORDH/ORDH.js'),
		ORDS: () => import('pages/ORDS/ORDS.js'),
		OSEL: () => import('pages/OSEL/OSEL.js'),
		PROD: () => import('pages/PROD/PROD.js'),
		PROFORMA: () => import('pages/PROFORMA/PROFORMA.js'),
		PROFORMA_CANCEL: () => import('pages/PROFORMA_CANCEL/PROFORMA_CANCEL.js'),
		PROFORMA_MODIFY: () => import('pages/PROFORMA_MODIFY/PROFORMA_MODIFY.js'),
		PROFORMA_OCST: () => import('pages/PROFORMA_OCST/PROFORMA_OCST.js'),
		PROFORMA_OSEL: () => import('pages/PROFORMA_OSEL/PROFORMA_OSEL.js'),
		QUOT: () => import('pages/QUOT/QUOT.js'),
		RMA: () => import('pages/RMA/RMA.js'),
		SRCH: () => import('pages/SRCH/SRCH.js'),
		TERMS: () => import('pages/TERMS/TERMS.js'),
		WISH: () => import('pages/WISH/WISH.js'),
		WLST: () => import('pages/WLST/WLST.js')
	},

	// A directory of page classes or scss files to be loaded by matching the `Screen` or `Page_Code` context variable against a regular expression
	regexImports: {},

	// A directory of page classes or scss files to be loaded by matching the `Screen` context variable
	screenImports: {}
});
